var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutepatnerNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 84.5V54.0625C43.0417 53.5208 41.8442 52.615 40.9075 51.345C39.9708 50.075 39.5017 48.6267 39.5 47C39.5 44.9167 40.2292 43.1458 41.6875 41.6875C43.1458 40.2292 44.9167 39.5 47 39.5C49.0833 39.5 50.8542 40.2292 52.3125 41.6875C53.7708 43.1458 54.5 44.9167 54.5 47C54.5 48.625 54.0317 50.0733 53.095 51.345C52.1583 52.6167 50.96 53.5225 49.5 54.0625V79.5H59.5V39.5H79.5V69.9375C80.9583 70.4792 82.1567 71.3858 83.095 72.6575C84.0333 73.9292 84.5017 75.3767 84.5 77C84.5 79.0833 83.7708 80.8542 82.3125 82.3125C80.8542 83.7708 79.0833 84.5 77 84.5C74.9167 84.5 73.1458 83.7708 71.6875 82.3125C70.2292 80.8542 69.5 79.0833 69.5 77C69.5 75.375 69.9692 73.9167 70.9075 72.625C71.8458 71.3333 73.0433 70.4375 74.5 69.9375V44.5H64.5V84.5H44.5Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutepatnerNotFound);
export default __webpack_public_path__ + "static/media/routepatnerNotFound.7e99775a413b19643b57b403dfdba3b1.svg";
export { ForwardRef as ReactComponent };